/**
 * Módulo de validadores para formularios Zoho
 */

// Expresiones regulares
const zf_DateRegex = new RegExp("^(([0][1-9])|([1-2][0-9])|([3][0-1]))[-](Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[-](?:(?:19|20)[0-9]{2})$");

const ZFPhoneRegex = {
    PHONE_INTE_ALL_REG: /^[+]{0,1}[()0-9-. ]+$/,
    PHONE_INTE_NUMERIC_REG: /^[0-9]+$/,
    PHONE_INTE_CONT_CODE_ENABLED_REG: /^[(0-9-.][()0-9-. ]*$/,
    PHONE_USA_REG: /^[0-9]+$/,
    PHONE_CONT_CODE_REG: /^[+][0-9]{1,4}$/
};

export class Validators {
    
    /**
     * Valida un número
     */
    static validateNumber(elem) {
        const validChars = "-0123456789";
        const numValue = elem.value.replace(/^\s+|\s+$/g, '');
        
        if (!numValue) return true;
        
        if (numValue.charAt(0) === "-" && numValue.length === 1) {
            return false;
        }
        
        for (let i = 0; i < numValue.length; i++) {
            const strChar = numValue.charAt(i);
            if ((strChar === "-") && (i !== 0)) {
                return false;
            }
            if (validChars.indexOf(strChar) === -1) {
                return false;
            }
        }
        return true;
    }

    /**
     * Valida formato de fecha
     */
    static validateDateFormat(inpElem) {
        const dateValue = inpElem.value.replace(/^\s+|\s+$/g, '');
        if (!dateValue) return true;
        return zf_DateRegex.test(dateValue);
    }

    /**
     * Valida moneda
     */
    static validateCurrency(elem) {
        const validChars = "0123456789.";
        let numValue = elem.value.replace(/^\s+|\s+$/g, '');
        
        if (numValue.charAt(0) === '-') {
            numValue = numValue.substring(1, numValue.length);
        }
        
        if (!numValue) return true;
        
        for (let i = 0; i < numValue.length; i++) {
            const strChar = numValue.charAt(i);
            if (validChars.indexOf(strChar) === -1) {
                return false;
            }
        }
        return true;
    }

    /**
     * Valida longitud de decimales
     */
    static validateDecimalLength(elem, decimalLen) {
        const numValue = elem.value;
        if (numValue.indexOf('.') >= 0) {
            const decimalLength = numValue.substring(numValue.indexOf('.') + 1).length;
            return decimalLength <= decimalLen;
        }
        return true;
    }

    /**
     * Valida email
     */
    static validateEmailID(elem) {
        const emailValue = elem.value;
        if (!emailValue) return true;
        
        const emailArray = emailValue.split(",");
        const emailExp = /^[\w]([\w\-.+&'/]*)@([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,22}$/;
        
        for (let i = 0; i < emailArray.length; i++) {
            if (!emailExp.test(emailArray[i].replace(/^\s+|\s+$/g, ''))) {
                return false;
            }
        }
        return true;
    }

    /**
     * Valida URL
     */
    static validateLiveUrl(elem) {
        const urlValue = elem.value?.replace(/^\s+|\s+$/g, '');
        if (!urlValue) return true;
        
        const urlregex = new RegExp("^(((https|http|ftps|ftp)://[a-zA-Z\\d]+((_|-|@)[a-zA-Z\\d]+)*(\\.[a-zA-Z\\d]+((_|-|@)[a-zA-Z\\d]+)*)+(:\\d{1,5})?)|((w|W){3}(\\.[a-zA-Z\\d]+((_|-|@)[a-zA-Z\\d]+)*){2,}(:\\d{1,5})?)|([a-zA-Z\\d]+((_|-)[a-zA-Z\\d]+)*(\\.[a-zA-Z\\d]+((_|-)[a-zA-Z\\d]+)*)+(:\\d{1,5})?))(/[-\\w.?,:'/\\\\+=&;%$#@()!~]*)?$", "i");
        return urlregex.test(urlValue);
    }

    /**
     * Valida teléfono
     */
    static validatePhone(inpElem) {
        const phoneFormat = parseInt(inpElem.getAttribute("phoneFormat"));
        const fieldInpVal = inpElem.value.replace(/^\s+|\s+$/g, '');
        
        if (phoneFormat === 1) {
            if (inpElem.getAttribute("valType") === 'code') {
                const codeRexp = ZFPhoneRegex.PHONE_CONT_CODE_REG;
                return !fieldInpVal || codeRexp.test(fieldInpVal);
            } else {
                let IRexp = ZFPhoneRegex.PHONE_INTE_ALL_REG;
                if (inpElem.getAttribute("phoneFormatType") === '2') {
                    IRexp = ZFPhoneRegex.PHONE_INTE_NUMERIC_REG;
                }
                return !fieldInpVal || IRexp.test(fieldInpVal);
            }
        } else if (phoneFormat === 2) {
            const InpMaxlength = inpElem.getAttribute("maxlength");
            const USARexp = ZFPhoneRegex.PHONE_USA_REG;
            return !fieldInpVal || (USARexp.test(fieldInpVal) && fieldInpVal.length == InpMaxlength);
        }
        return true;
    }

    /**
     * Valida que un campo no esté vacío
     */
    static validateRequired(fieldObj) {
        if (!fieldObj) return false;
        
        if (fieldObj.nodeName === 'OBJECT') {
            // Validación de firma - se maneja en signature.js
            return true;
        }
        
        if (fieldObj.nodeName === 'SELECT') {
            return fieldObj.options[fieldObj.selectedIndex].value !== '-Select-';
        }
        
        if (fieldObj.type === 'checkbox' || fieldObj.type === 'radio') {
            return fieldObj.checked;
        }
        
        const value = fieldObj.value?.replace(/^\s+|\s+$/g, '');
        return value && value.length > 0;
    }

    /**
     * Valida campos de grupo (radio buttons, checkboxes)
     */
    static validateGroup(fieldGroup) {
        if (!fieldGroup || !fieldGroup.length) return false;
        
        for (let i = 0; i < fieldGroup.length; i++) {
            if (fieldGroup[i].checked) {
                return true;
            }
        }
        return false;
    }

    /**
     * Valida que dos campos coincidan
     */
    static validateSameAs(fieldObj, form) {
        const sameAs = fieldObj.getAttribute("sameAs");
        if (!sameAs) return true;
        
        const sameAsField = form[sameAs];
        return sameAsField && sameAsField.value === fieldObj.value;
    }
}